<template>
  <div>
    <BrandEditor :campaign-id="campaign.campaignId" />

    <!-- <StoreNameUpdater class="p-4 pb-0" />

    <EmailUpdater class="p-4 pb-0" />

    <IndustrySelector class="p-4" /> -->
  </div>
</template>

<script>
import BrandEditor from "@/components/Brand/BrandEditor";
// import IndustrySelector from "@/components/Editor/Settings/IndustrySelector";
// import EmailUpdater from "@/components/Editor/Settings/EmailUpdater";
// import StoreNameUpdater from "@/components/Editor/Settings/StoreNameUpdater";

export default {
  name: "Settings",
  components: {
    BrandEditor,
    // EmailUpdater,
    // IndustrySelector,
    // StoreNameUpdater
  },
  props: {
    campaign: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped>
.title {
  @apply text-support text-sm font-bold font-sans leading-normal;
}

.change-theme-toggle {
  @apply p-0 m-0 text-brand outline-none;
  font-size: 14px;
  line-height: 1;
  vertical-align: text-top;

  &:hover {
    @apply underline;
  }
}

>>> .brand-colors {
  @apply mb-0;
}
</style>
